/**
 * Floating Chat Button Component
 * Supports drag-to-move via onPointerDown (icon can be repositioned on screen).
 */
import React from 'react';

const ChatButton = ({ onClick, onPointerDown }) => {
  return (
    <button
      type="button"
      className={`afgcoin-chatbot-button${onPointerDown ? ' afgcoin-chatbot-button-draggable' : ''}`}
      onClick={onClick}
      onPointerDown={onPointerDown}
      style={onPointerDown ? { touchAction: 'none' } : undefined}
      aria-label="Open chat"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

export default ChatButton;

